import isClient from '@mobi/utils/browser/isClient'

/**
 *
 * @param {string} experimentId O ID do experimento que deverá ser verificado qual variante está ativa
 * @returns Retorna uma promise que resolve com a variante ativa do experimento
 */

export const getOptimizeVariant = (experimentId) => {
  return new Promise((resolve, reject) => {
    const getOptimizeVariantInterval = setInterval(() => {
      try {
        if (isClient() && window.google_optimize) {
          clearInterval(getOptimizeVariantInterval)
          const variant = window.google_optimize.get(experimentId)

          resolve(variant)
        }
      } catch (error) {
        reject(error)
      }
    }, 100)
  })
}
